// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const GROUP_LIST = "Zoznam skup\u00edn";
export const GROUPS_CREATE_NEW_GROUP = "Zalo\u017e skupinu";
export const LIST_OF_FORUMS = "Zoznam f\u00f3r";
export const SELECT_CATEGORY = "Vyber kateg\u00f3riu";
export const SEO_TITLE_GROUP_LIST = "Zoznam skup\u00edn";
export const SEO_TITLE_SELECT_CATEGORY = "Vyber kateg\u00f3riu";
